import * as React from 'react';
import StepButton from '@material-ui/core/StepButton';

const CustomStepButton = React.forwardRef((props, ref) => {
    return <StepButton {...props} ref={ref} />;
});

export { CustomStepButton as StepButton };
